import React from 'react';
import { StyledFlexbox } from './Flexbox.styled';
export const defaultProps = {
  dataTest: 'flexbox',
  tagName: 'div',
  display: 'flex',
  flexDirection: 'row'
};
export const Flexbox = ({
  display = defaultProps.display,
  flexDirection = defaultProps.flexDirection,
  justifyContent,
  alignItems,
  alignSelf,
  alignContent,
  flexBasis,
  flexGrow,
  flexShrink,
  flexWrap,
  order,
  gap,
  tagName = defaultProps.tagName,
  children,
  dataTest = defaultProps.dataTest,
  margins
}) => {
  return React.createElement(StyledFlexbox, {
    display: display,
    flexDirection: flexDirection,
    justifyContent: justifyContent,
    alignItems: alignItems,
    alignSelf: alignSelf,
    alignContent: alignContent,
    flexBasis: flexBasis,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    flexWrap: flexWrap,
    order: order,
    gap: gap,
    margins: margins,
    as: tagName,
    "data-test": dataTest
  }, children);
};